// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jj-0";
export var discountCodeInput = "_jj-1";